// 視覚効果を減らす設定をユーザーがしているかどうか
export default function isMotionReduced() {
	return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
